/**
 * iurop-faq.js — pestañas de categoría de las FAQs (Glucody).
 * Delegación: clic en [data-faq-tab] activa la pestaña y muestra solo los
 * [data-faq-item] de esa categoría dentro de la misma sección [data-faq].
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-faq-tab]');
    if (!tab) return;
    var section = tab.closest('[data-faq]');
    if (!section) return;
    var cat = tab.getAttribute('data-faq-tab');

    section.querySelectorAll('[data-faq-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
    });

    section.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var match = item.getAttribute('data-category') === cat;
      item.hidden = !match;
      if (!match) item.removeAttribute('open');
    });
  });
})();
